import React from 'react';
import Button from '../atoms/button';
import { IoLogoTwitter, IoLogoFacebook, IoLogoInstagram } from "react-icons/io5";
import './footer.css';

const Footer = () => {
  return (
    <footer>
      <nav>
        <div className="footer-content">
          <div className="nav-links">
            <ul>
              <li><a href="/menu">Menu</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-socials">
            <a href="https://twitter.com"><IoLogoTwitter /></a>
            <a href="https://facebook.com"><IoLogoFacebook /></a>
            <a href="https://instagram.com"><IoLogoInstagram /></a>
          </div>
        </div>
      </nav>
      <Button variant="text" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Top of Page</Button>
    </footer>
  );
};

export default Footer;
